import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.698 21.664a9.998 9.998 0 0 1-.698.031c-1.354 0-3.814-.385-6.655-1.469a.711.711 0 1 1 .508-1.329c2.663 1.016 4.976 1.376 6.147 1.376.215 0 .48-.017.765-.043.079-1.051.214-2.038.396-2.802h-3.295a.711.711 0 0 1-.711-.712c0-2.974 1.282-6.66 2.669-9.246H5.33a.712.712 0 0 0-.711.711V23.83c0 .393.318.712.71.712h11.48a22 22 0 0 1-.111-2.877ZM10.31 11.026a.712.712 0 0 1 1.422 0v1.423a.712.712 0 0 1-1.422 0v-1.423Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M26.67 7.47h-9.206c-1.255 2.132-2.654 5.61-2.86 8.535h3.53a.712.712 0 0 1 .645 1.012c-.29.619-.477 1.747-.575 3.007a23.245 23.245 0 0 0 3.945-1.125.707.707 0 0 1 .917.41.709.709 0 0 1-.411.918 24.197 24.197 0 0 1-4.525 1.258 24.403 24.403 0 0 0 .1 3.056h8.44a.712.712 0 0 0 .71-.712V8.181a.712.712 0 0 0-.71-.711Zm-6.402 4.979a.712.712 0 0 1-1.423 0v-1.423a.712.712 0 0 1 1.423 0v1.423Zm-1.631-7.617a.712.712 0 0 0-1.006 0c-.554.553-1.192 1.487-1.808 2.636h1.64c.426-.723.834-1.292 1.174-1.63a.712.712 0 0 0 0-1.006Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.64 26.17c-.186-.205-.322-.818-.41-1.634h-1.419c.138 1.225.401 2.218.821 2.638a.68.68 0 0 0 .485.202.722.722 0 0 0 .496-.202.727.727 0 0 0 .028-1.004Z"
    }
  )
);
var SvgMacFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MacFilled_default = SvgMacFilled;

export { MacFilled_default as default };
